<div class="mobile-brand-bar">
  <app-svg-loader *ngIf="currentTheme === 'dark-theme'" height="24px" url="assets/logos/tail-one-logo-white.svg"></app-svg-loader>
  <app-svg-loader *ngIf="currentTheme === 'light-theme'" height="24px" url="assets/logos/tail-one-logo-dark.svg"></app-svg-loader>
  <div class="cta-wrapper">
    {{ctaText}}
  </div>
</div>

<app-split-page-wrapper>
  <div left>
    <div class="brand-element">
      <div class="logo-wrapper">
        <div class="logo-ball"></div>
        <app-svg-loader *ngIf="currentTheme === 'dark-theme'" height="34px" url="assets/logos/tail-one-logo-white.svg"></app-svg-loader>
        <app-svg-loader *ngIf="currentTheme === 'light-theme'" height="34px" url="assets/logos/tail-one-logo-dark.svg"></app-svg-loader>
      </div>
      <div class="cta-wrapper">
        {{ctaText}}
      </div>
    </div>
  </div>
  <div right>
    <div class="auth-form-wrapper">
      <h2>Forgot Password</h2>

      <app-base-input id="forgotEmail" placeholder="email" mb="24px" [(ngModel)]="email" type="email" isFluid="true" autocomplete="on" (onEnter)="sendResetEmail()"></app-base-input>

      <app-alert-message *ngIf="errorMessage" type="error" mb="24px">{{errorMessage}}</app-alert-message>
      <app-alert-message *ngIf="successMessage" type="success" mb="24px">{{successMessage}}</app-alert-message>

      <app-primary-btn (click)="sendResetEmail()" mb="24px" [disabled]="isSending" gradient="true">
        <span *ngIf="!isSending">Send Reset Email</span>
        <app-spinner variant="btn-spinner" *ngIf="isSending" size="20px"></app-spinner>
      </app-primary-btn>

      <div class="auth-link-wrap">
           <a class="link" [routerLink]="['/login']">Go Back</a>
      </div>
    </div>
  </div>
</app-split-page-wrapper>
